import BulkCampaigns from "./BulkCampaigns";

export default function CampaignBulkSection(props) {
  const { projectId, isViewOnly } = props;

  return <BulkCampaigns workspaceId={projectId} isViewOnly={isViewOnly}/>;
}
